<template>
  <div>
    <v-dialog
      v-model="getModalCadastroAtividadePosVenda"
      persistent
      max-width="720px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>Registrar Atividade</v-card-title>
        <v-card-text>
          <v-form class="px-3 pt-3" ref="formAtividadePosVenda">
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="getAtividadePosVenda.data_atividade"
                  label="Data"
                  outlined
                  dense
                  type="date"
                  class="ml-1 mr-1"
                  :rules="rules.data_atividade"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="getAtividadePosVenda.hora_atividade"
                  label="Horário"
                  outlined
                  dense
                  type="time"
                  class="ml-1 mr-1"
                  :rules="rules.hora_atividade"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md12>
                <v-textarea
                  v-model="getAtividadePosVenda.descricao"
                  label="Descrição"
                  outlined
                  dense
                  class="ml-1 mr-1"
                  :rules="rules.descricao"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="default"
            outlined
            dense
            @click="setModalCadastroAtividadePosVenda(false)"
            >Voltar</v-btn
          >
          <v-btn
            color="error"
            @click="setModalExcluirAtividadePosVenda(true)"
            outlined
            v-if="getAtividadePosVenda.id"
            >Excluir</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="success" outlined dense @click="salvar()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ModalExcluir />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ModalExcluir from "@/pages/crm/posVenda/atividade/ModalExcluir";
export default {
  components: {
    ModalExcluir,
  },
  data() {
    return {
      rules: {
        data_atividade: [(v) => !!v || "Campo obrigatório."],
        hora_atividade: [(v) => !!v || "Campo obrigatório."],
        descricao: [(v) => !!v || "Campo obrigatório."],
      },
    };
  },
  computed: {
    ...mapGetters([
      "getModalCadastroAtividadePosVenda",
      "getFuncionariPosVenda",
      "getAtividadePosVenda",
      "getPosVenda",
    ]),
  },
  methods: {
    ...mapActions([
      "setModalCadastroAtividadePosVenda",
      "salvarAtividadePosVenda",
      "atualizarAtividadePosVenda",
      "setModalExcluirAtividadePosVenda",
    ]),
    salvar() {
      if (this.$refs.formAtividadePosVenda.validate() == false) {
        return;
      }

      this.getAtividadePosVenda.pos_venda_id = this.getPosVenda.id;
      console.log(this.getAtividadePosVenda);
      if (this.getAtividadePosVenda.id) {
        this.atualizarAtividadePosVenda(this.getAtividadePosVenda);
      } else {
        this.salvarAtividadePosVenda(this.getAtividadePosVenda);
      }
    },
  },
};
</script>